/* eslint-disable max-len */
import styled from 'styled-components';
import InternalInIconDark from '../../assets/images/internal-in-icon.svg';
import InternalInIconLight from '../../assets/images/internal-in-icon-light.svg';

const InternalInIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${InternalInIconDark}") no-repeat left center`
      : `url("${InternalInIconLight}") no-repeat left center`};
  background-size: 23px 21px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  height: 21px;
  width: 23px;
`;

export default InternalInIcon;
